// Messages for portal/team/InviteTeammateModal (auto-merged by lib/i18n.ts).
export const en = {
  'portal.invite_teammate.title': 'Invite teammate',
  'portal.invite_teammate.cancel': 'Cancel',
  'portal.invite_teammate.send': 'Send invite',
  'portal.invite_teammate.intro':
    "They'll get a one-time link to set a password and sign in to your company's portal.",
  'portal.invite_teammate.email': 'Email',
  'portal.invite_teammate.email_placeholder': 'name@company.com',
  'portal.invite_teammate.role': 'Role',
  'portal.invite_teammate.role.company_admin': 'Company Admin',
  'portal.invite_teammate.role.member': 'Member',
}

export const zhTW = {
  'portal.invite_teammate.title': '邀請成員',
  'portal.invite_teammate.cancel': '取消',
  'portal.invite_teammate.send': '送出邀請',
  'portal.invite_teammate.intro': '他們將收到一次性連結，用以設定密碼並登入貴公司的客戶入口。',
  'portal.invite_teammate.email': '電子郵件',
  'portal.invite_teammate.email_placeholder': 'name@company.com',
  'portal.invite_teammate.role': '角色',
  'portal.invite_teammate.role.company_admin': '公司管理員',
  'portal.invite_teammate.role.member': '成員',
}
